// extracted by mini-css-extract-plugin
module.exports = {"container":"Upload_container__3IuRB","input":"Upload_input__1ykAf"};